export const DEFAULT_ARTWORK = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#2f2a1f" />
      <stop offset="100%" stop-color="#8f2f1e" />
    </linearGradient>
  </defs>
  <rect width="240" height="240" fill="url(#bg)" />
  <circle cx="120" cy="120" r="74" fill="rgba(255,255,255,0.18)" />
  <circle cx="120" cy="120" r="30" fill="rgba(20,20,20,0.45)" />
  <rect x="112" y="56" width="16" height="40" rx="8" fill="rgba(255,255,255,0.72)" />
</svg>
`)}`;

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function formatDuration(value) {
  if (!Number.isFinite(value) || value < 0) {
    return '--:--';
  }

  const total = Math.floor(value);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function normalizeTag(tag) {
  return String(tag || '').trim().toLowerCase();
}

export function formatTagLabel(tag) {
  const clean = normalizeTag(tag);
  if (!clean) {
    return 'Non classe';
  }

  return clean
    .split(/[_-]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
